import React, {memo, useState} from "react";
import Form from "./form";
import {Table, Pagination, Button} from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';

function DataTable({response, setPage, change, setChange, deleteItem}) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState();


    const editItem = async (userId) => {
        await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    setUserData(response.data.data);
                    setShow(true);
                } else {
                    console.log(response);
                }
            });
    }

    const paymentCreate = async (userId, amount) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/payment/create`, {paymentEditorId: userId, paymentAmount: amount})
            .then(function (response) {
                if (response.data.status === true) {
                    Swal.fire({
                        text: "İşlem başarıyla tamamlandı.",
                        icon: "success",
                        confirmButtonText: "Tamam",
                    });
                    setChange(change + 1);
                } else {
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                        confirmButtonText: "Tamam",
                    });
                }
            });
    }

    return (
        <>
            <div className="bg-white rounded border mb-3">
                <Table hover responsive className="mb-0">
                    <thead>
                    <tr>
                        <th>Adı Soyadı</th>
                        <th>E-Posta</th>
                        <th>Telefon</th>
                        <th>TC Kimlik No</th>
                        <th>Yetki</th>
                        <th>Ödenmesi Gereken (Geçen ay)</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>

                    {response.data && (response.data).map((element) => (
                        <tr key={element.userId}>
                            <td>
                                {element.userPhoto != null ?
                                    <img className={"rounded bg-primary me-2"}
                                         style={{width: 30, height: 30}} src={element.userPhoto}/>
                                    :
                                    <img className={"rounded bg-dark me-2"}
                                         style={{width: 30, height: 30}} src={require('../../../src/images/nophoto.png')}/>
                                }
                                {element.userName}
                            </td>
                            <td>{element.userEmail}</td>
                            <td>{element.userPhone != null ? element.userPhone : "-"}</td>
                            <td>{element.userNumber != null ? element.userNumber : "-"}</td>
                            <td>
                                {element.userRole == 0 ? "Editör" : ""}
                                {element.userRole == 1 ? "Yetkili" : ""}
                                {element.userRole == 2 ? "Yönetici" : ""}
                            </td>
                            <td>
                                {element.sureIncome}₺ <small>({element.sureIncomeCount} adet yayımlanmış içerik)</small>
                                {element.sureIncome > 0 && <Button variant="success" className="py-0 px-2 ms-2" onClick={() =>
                                    Swal.fire({
                                        html: `<strong>${element.userName}</strong> kullanıcısına <strong>${element.sureIncome}₺</strong> ödeme yapmayı onaylıyor musun? <small class="text-danger d-block mt-2">Bu işlem geri alınamaz!</small>`,
                                        icon: "question",
                                        confirmButtonText: "Evet",
                                        showCancelButton: true,
                                        cancelButtonText: "Hayır",
                                        allowEnterKey: false,
                                        preConfirm: () => {
                                            paymentCreate(element.userId, element.sureIncome);
                                        }
                                    })
                                }>Öde</Button>}
                            </td>

                            <td className="text-end">
                                {element.userRole != 2 ?
                                    <>
                                        <Button variant="dark" className="py-0 px-2 me-2"
                                                onClick={() => editItem(element.userId)}>Düzenle</Button>

                                        <Button variant="danger" className="py-0 px-2" onClick={() =>
                                            Swal.fire({
                                                html: `<strong>${element.userName}</strong> kullanıcısını silmek istiyor musun?`,
                                                icon: "question",
                                                confirmButtonText: "Evet",
                                                showCancelButton: true,
                                                cancelButtonText: "Hayır",
                                                allowEnterKey: false,
                                                preConfirm: () => {
                                                    deleteItem(element.userId);
                                                }
                                            })
                                        }>Sil</Button>
                                    </>

                                    : null}

                            </td>
                        </tr>
                    ))}

                    </tbody>
                </Table>
            </div>
            <Pagination>
                {Array.from({length: response.pageCount}, (item, index) =>
                    <Pagination.Item key={index} onClick={(page) => setPage(index + 1)}
                                     active={response.page === index}>{(index + 1)}</Pagination.Item>
                )}
            </Pagination>

            {show &&
                <Form change={change} setChange={setChange} show={show} setShow={setShow} userData={userData}/>}
        </>
    )

}

export default memo(DataTable);
